import { get, post } from '../../services/request';

export async function userGeneralInfo() {
    const response = await get('/ui/user/general');
    return response;
}

export async function updateGeneralInfo({
    firstName,
    language,
    lastName,
    locale,
    middleName,
    phone,
    phoneCountryCode,
    prefix,
    suffix,
    timezone,
}) {
    const response = await post('/ui/user/general', {
        firstName,
        language,
        lastName,
        locale,
        middleName,
        phone,
        phoneCountryCode,
        prefix,
        suffix,
        timezone,
    });
    return response;
}

export async function userEmailsInfo() {
    const response = await get('/ui/user/emails');
    return response;
}

/**
 * Resets password in MyAccount
 * @param {string} oldPassword
 * @param {string} newPassword
 */
export async function changePassword(oldPassword, newPassword) {
    const response = await post('/ui/user/change-password', {
        oldPassword,
        newPassword,
    });
    return response;
}

export function requestEmailUpdate(email, frcToken, language) {
    return post('/ui/username/request-update', {
        email,
        'frc-captcha-response': frcToken,
        language,
    });
}
